import { Injectable } from '@angular/core';
import { ExportJSONFileModel } from '../models/export-file.model';
import { ExportSanitizerReservedWords } from './export-sanitizer-reserved-words';
import { IExportSanitizer } from './export-sanitizer.interface';
import { ExportSanitizer } from './export.sanitizier';

@Injectable()
export class ExportSanitizerService {
	private sanitizers: IExportSanitizer[] = [];

	public constructor(exportSanitizer: ExportSanitizer, exportSanitizerReservedWords: ExportSanitizerReservedWords) {
		this.sanitizers.push(exportSanitizer);
		this.sanitizers.push(exportSanitizerReservedWords);
	}

	public sanitize(model: ExportJSONFileModel): ExportJSONFileModel {
		for (const sanitizer of this.sanitizers) {
			model = sanitizer.sanitize(model);
		}

		return model;
	}
}
